import {gql} from "@apollo/client";

export const GET_SELF = gql`
    query getSelf {
        getSelf{
            id 
            displayName 
            profileImageUrl 
            discordId 
            coins 
            isAdmin 
        }
    }
`;

export const HOMEPAGE_LEADERBOARD = gql`
    query getLeaderboard($month: Int) {getLeaderboard(month: $month){PlayerName PlayerId PlayerImage WageredAmount }}
`;